module.exports = __webpack_public_path__ + "img/2_182.c1dfff9f.png";